import { useEffect } from 'react';
export var useInternalRef = function useInternalRef(ref, internalRef) {
  return useEffect(function () {
    if (ref && internalRef) {
      Object.assign(ref, internalRef);
    }
  }, [ref, internalRef]);
};